/* eslint-disable react/no-children-prop */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Link } from 'react-router-dom';
import { MenuItem } from 'semantic-ui-react';

const MenuLinkItem = ({
  label, to, activeOnlyWhenExact, otherCondition,
}) => (otherCondition ? (
  <Route
    path={to}
    exact={activeOnlyWhenExact}
    children={({ match }) => (
      <MenuItem active={!!match}>
        <Link to={to}>{label}</Link>
      </MenuItem>
    )}
  />
) : null);

MenuLinkItem.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  activeOnlyWhenExact: PropTypes.bool,
  otherCondition: PropTypes.bool,
};

MenuLinkItem.defaultProps = {
  activeOnlyWhenExact: true,
  otherCondition: true,
};

export default MenuLinkItem;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuLinkItem.js